import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Send } from "lucide-react";
import api from "@/lib/api";
import EmptyState from "@/components/EmptyState";
import StatusBadge from "@/components/StatusBadge";

export default function Campaigns() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/campaigns")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
            Outbound campaigns
          </div>
          <h1 className="font-display text-4xl font-semibold tracking-tight mt-2">
            Campaigns
          </h1>
        </div>
        <button
          onClick={() => navigate("/campaigns/new")}
          data-testid="create-campaign-button"
          className="flex items-center gap-2 bg-white text-black px-4 py-2 rounded-md text-sm font-medium hover:bg-neutral-200 transition-colors"
        >
          <Plus className="w-4 h-4" strokeWidth={1.8} /> New campaign
        </button>
      </div>

      {loading ? (
        <div className="text-neutral-500 text-sm font-mono">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState
          icon={Send}
          title="No campaigns yet"
          description="Build a multi-step outreach sequence, attach an inbox, and let OutreachOS deliver your replies."
          action={
            <button
              onClick={() => navigate("/campaigns/new")}
              data-testid="empty-create-campaign-cta"
              className="flex items-center gap-2 bg-white text-black px-4 py-2 rounded-md text-sm font-medium"
            >
              <Plus className="w-4 h-4" strokeWidth={1.8} /> Create first campaign
            </button>
          }
        />
      ) : (
        <div className="border border-[#1a1a1a] bg-[#0d0d0d] rounded-lg overflow-hidden">
          <table className="w-full">
            <thead className="text-[10px] uppercase tracking-[0.18em] text-neutral-500 font-mono">
              <tr className="border-b border-[#1a1a1a]">
                <th className="text-left px-6 py-3">Name</th>
                <th className="text-left px-6 py-3">Status</th>
                <th className="text-right px-6 py-3">Leads</th>
                <th className="text-right px-6 py-3">Sent</th>
                <th className="text-right px-6 py-3">Open</th>
                <th className="text-right px-6 py-3">Reply</th>
              </tr>
            </thead>
            <tbody className="font-mono text-sm">
              {items.map((c) => (
                <tr
                  key={c.id}
                  onClick={() => navigate(`/campaigns/${c.id}`)}
                  className="border-b border-[#1a1a1a] hover:bg-[#111] cursor-pointer"
                  data-testid={`campaign-row-${c.id}`}
                >
                  <td className="px-6 py-3 text-white">{c.name}</td>
                  <td className="px-6 py-3">
                    <StatusBadge status={c.status} />
                  </td>
                  <td className="px-6 py-3 text-right">{c.lead_count}</td>
                  <td className="px-6 py-3 text-right">{c.sent_count}</td>
                  <td className="px-6 py-3 text-right">{c.open_rate}%</td>
                  <td className="px-6 py-3 text-right">{c.reply_rate}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
